import ReactGA from "react-ga4";

export const handleGAEvents = (data) => {
    const { action } = data;
    if (action) {
        ReactGA.event(data);
    } else {
        console.log("Please provide action", data)
    }
}